// extracted by mini-css-extract-plugin
export var ldsSpinner = "spinner-module--lds-spinner--BMWvN";